import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * We can replace this with useSearchParams from react-router-dom v7 once we upgrade
 */
export const useQueryParams = () => {
  const location = useLocation();

  // Parse query parameters from URL
  const queryParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};

    for (const [key, value] of searchParams.entries()) {
      // Handle multiple values for the same key
      if (params[key]) {
        if (Array.isArray(params[key])) {
          params[key].push(value);
        } else {
          params[key] = [params[key], value];
        }
      } else {
        params[key] = value;
      }
    }

    return params;
  }, [location.search]);

  return queryParams;
};
